import { createFileRoute, redirect } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/lifemart/preview")({
  head: () => seoHead("/lifemart/preview"),
  beforeLoad: () => {
    throw redirect({ to: "/lifemart", replace: true });
  },
});